module.exports = __webpack_public_path__ + "4f280347f69e51cd656ad0a665f38306.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/tick.svg
// module id = GnHr
// module chunks = 0